import React from "react";

// stealCap: 'unlimited' o un número (tope de veces que se puede jugar/robar la misma casilla
// en Modo Robo). Default 3, configurable desde el botón de configuración de la Home.
const StealCapContext = React.createContext({
    stealCap: 3,
    setStealCap: () => {}
});

export default StealCapContext;
